/**
 * Shared visual mappings for the captions UI. Kept in one place so a new
 * status / severity only needs to be added once and the Review Queue,
 * Caption Editor (and any future caption surface) stay in lockstep.
 */

export const STATUS_COLOR = {
  // Dispatched to the queue but a worker hasn't picked it up yet.
  // Grey (default) so it reads as "in flight, no action needed" — the
  // colour escalates to blue (processing) the moment the worker
  // claims the row.
  queued: "default",
  processing: "info",
  auto_pending_review: "warning",
  human_reviewed: "success",
  human_edited: "success",
  failed: "error",
};

export const SEVERITY_COLOR = {
  low: "default",
  medium: "warning",
  high: "error",
};

/**
 * Human-readable provider name shared across the Review Queue, the
 * Editor's source picker, and any future caption surface.
 */
export function prettySource(source) {
  switch (source) {
    case "whisper":
      return "Whisper-1";
    case "assemblyai":
      return "AssemblyAI";
    case "manual":
      return "Manual";
    case "translated":
      return "Translated";
    default:
      return source || "Unknown";
  }
}
